export const mutations = {
    SET_ACCESSIBLE_MODE(state, enabled) {
        state.accessibility.enabled = enabled;
    },
    SET_ACCESSIBLE_OPTIONS(state, options) {
        state.accessibility.options = { ...state.accessibility.options, ...options };
    }
};
